import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Chip, Typography, TextField,
  FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle,
  DialogContent, DialogActions
} from '@mui/material';
import { Add, Edit, Delete, Visibility } from '@mui/icons-material';
import { getArticles, deleteArticle } from '../services/api';

function ArticlesPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ status: '', articleType: '' });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, article: null });
  const navigate = useNavigate();

  useEffect(() => {
    loadArticles();
  }, [filter]);

  const loadArticles = async () => {
    try {
      const params = {};
      if (filter.status) params.status = filter.status;
      if (filter.articleType) params.articleType = filter.articleType;
      const { data } = await getArticles(params);
      setArticles(data.articles || data);
    } catch (error) {
      console.error('Erreur chargement articles:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteArticle(deleteDialog.article._id);
      setDeleteDialog({ open: false, article: null });
      loadArticles();
    } catch (error) {
      console.error('Erreur suppression:', error);
    }
  };

  const statusColors = { draft: 'default', review: 'warning', published: 'success', archived: 'error' };
  const typeLabels = { actualite: 'Actualite', recherche: 'Recherche', temoignage: 'Temoignage', conseil: 'Conseil', evenement: 'Evenement' };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">Articles</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => navigate('/articles/new')}>
          Nouvel article
        </Button>
      </Box>

      <Card sx={{ mb: 3, p: 2 }}>
        <Box display="flex" gap={2}>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Statut</InputLabel>
            <Select value={filter.status} label="Statut" onChange={(e) => setFilter({ ...filter, status: e.target.value })}>
              <MenuItem value="">Tous</MenuItem>
              <MenuItem value="draft">Brouillon</MenuItem>
              <MenuItem value="published">Publie</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Type</InputLabel>
            <Select value={filter.articleType} label="Type" onChange={(e) => setFilter({ ...filter, articleType: e.target.value })}>
              <MenuItem value="">Tous</MenuItem>
              {Object.entries(typeLabels).map(([key, label]) => (
                <MenuItem key={key} value={key}>{label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Card>

      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Titre</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Statut</TableCell>
                <TableCell>Vues</TableCell>
                <TableCell>Date</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {articles.map((article) => (
                <TableRow key={article._id} hover>
                  <TableCell><Typography fontWeight="medium">{article.title}</Typography></TableCell>
                  <TableCell>{typeLabels[article.articleType] || article.articleType}</TableCell>
                  <TableCell><Chip size="small" label={article.status} color={statusColors[article.status]} /></TableCell>
                  <TableCell>{article.views}</TableCell>
                  <TableCell>{new Date(article.updatedAt).toLocaleDateString('fr-FR')}</TableCell>
                  <TableCell align="right">
                    <IconButton size="small" onClick={() => navigate(`/articles/${article._id}`)}><Edit /></IconButton>
                    <IconButton size="small" color="error" onClick={() => setDeleteDialog({ open: true, article })}><Delete /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, article: null })}>
        <DialogTitle>Confirmer la suppression</DialogTitle>
        <DialogContent>Supprimer "{deleteDialog.article?.title}" ?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, article: null })}>Annuler</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>Supprimer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ArticlesPage;
